import fa from '@/internationalization/trans/chefs/fa/fa.json';
export default {
  trans: fa,
};
